export const SURVEY_ACTIVITY_LOG_MESSAGES = {
  manualProcessingToggled: 'MANUAL_PROCESSING_TOGGLED',
  confirmedHighCpi: 'CONFIRMED_HIGH_CPI',
} as const;

export type SurveyActivityLogMessage =
  (typeof SURVEY_ACTIVITY_LOG_MESSAGES)[keyof typeof SURVEY_ACTIVITY_LOG_MESSAGES];
